"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const MonitoringNodeValidation_1 = require("../validations/MonitoringNodeValidation");
const CloudwatchOptions_1 = require("../config/CloudwatchOptions");
const utils_1 = require("../helper/utils");
const fetchOutputKeys_1 = require("../helper/fetchOutputKeys");
const cloudProvider_1 = __importDefault(require("../types/cloudProvider"));
class MonitoringNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.MONITORING };
    if (props.type !== types_1.NODE_TYPES.MONITORING)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    const ns = "AWS/EC2";
    const nsObject = CloudwatchOptions_1.nsMap["AWS/EC2"];
    let defaultQuery = {
      Namespace: ns,
      MetricName: nsObject.MetricNames[0],
      Dimensions: [{ Name: nsObject.Dimensions[0] }],
      Period: CloudwatchOptions_1.period[0].value,
      Stat: CloudwatchOptions_1.stat[0]
    };
    let deserializeData = {
      StartTime: "",
      EndTime: "",
      Queries: [defaultQuery]
    };
    if (nodeData) {
      deserializeData = {
        StartTime: nodeData.StartTime,
        EndTime: nodeData.EndTime,
        Queries: nodeData.Queries
      };
    }
    return JSON.parse(JSON.stringify(deserializeData));
  }
  serialize(uiData) {
    let data = uiData;
    // modify data if required
    return data;
  }
  getAttachedApis(selectedResource) {
    let apis = [];
    let myApi = {
      service: "CloudWatch",
      method: "getMetricData",
      type: types_1.AwsApiType.AddOn
    };
    apis.push(myApi);
    // get attached apis of its own selected resource
    apis = apis.concat(this.getAttachedApisFromParent(selectedResource));
    if (selectedResource.path) {
      return apis.filter(x =>
        selectedResource.path.includes(utils_1.getPrettyName(x.method))
      );
    }
    return apis;
  }
  /**
   *  return extra resources which are path resources
   *  e.g for resource node with addons resources are
   *  resourceNodeId-Instances, resourceNodeId-Instances-addons-Volumes, resourceNodeId-Instances-addOns-SecurityGroups
   *  returns filterNodeId-Instances-addons-Volumes, filterNodeId-Instances-addOns-SecurityGroups
   *
   */
  async getAvailableResourcesForAllPaths() {
    let availableResources = [];
    const selectedResource = this.getSelectedResource();
    if (!selectedResource || !selectedResource.nodeRef) return [];
    let options = await selectedResource.nodeRef.getAvailableResources();
    options = options.filter(x =>
      utils_1.selectedResourceNotEquals(x, selectedResource)
    );
    for (let option of options) {
      let postFix = option.label.substring(option.label.indexOf(".") + 1);
      let label = [this.getNodeName(), postFix].join(".");
      availableResources.push({
        nodeRef: this,
        selectedResourceId: this.id,
        path: option.path,
        label,
        context: option.context
      });
    }
    return availableResources;
  }
  async getAvailableResources() {
    let selectedResource = this.getSelectedResource();
    let availableResources = [];
    if (!selectedResource) return [];
    if (selectedResource.label === "NONE") {
      return [
        {
          label: [
            this.getNodeName(),
            utils_1.getPrettyName("getMetricData")
          ].join("."),
          nodeRef: this,
          selectedResourceId: this.id,
          path: "",
          context: {
            outputPath: ""
          }
        }
      ];
    }
    let splitted = selectedResource.label.split(".");
    let label = [this.getNodeName(), splitted[splitted.length - 1]].join(".");
    if (!selectedResource.path) {
      let avRes = await this.getAvailableResourcesForAllPaths();
      availableResources = availableResources.concat(avRes);
    }
    availableResources.push({
      nodeRef: this,
      selectedResourceId: this.id,
      path: "",
      label,
      context: {
        outputPath: ""
      }
    });
    let addOnLabel = [
      label,
      "addOns",
      utils_1.getPrettyName("getMetricData")
    ].join(".");
    availableResources.push({
      label: addOnLabel,
      nodeRef: this,
      selectedResourceId: this.id,
      path: ["addOns", utils_1.getPrettyName("getMetricData"), "data"].join(
        "."
      ),
      context: {
        outputPath: `addOns.${utils_1.getPrettyName("getMetricData")}.data`
      }
    });
    return availableResources;
  }
  /**
   * get output keys for given resource(optional) from its own selected resource
   * @param params
   */
  async getOutputKeys(params) {
    let nodeData = this.getNodeData();
    let selectedResource = this.getSelectedResource();
    if (!selectedResource) return [];
    if (selectedResource.label === "NONE") {
      return await fetchOutputKeys_1.fetchOutputKeys(
        this.getDataResolver(),
        "CloudWatch",
        "getMetricData"
      );
    }
    let nodeRef = selectedResource.nodeRef;
    if (!nodeRef) return [];
    let outputKeys = await nodeRef.getOutputKeys(params);
    const addOnOutputKeys = await fetchOutputKeys_1.fetchOutputKeys(
      this.getDataResolver(),
      "CloudWatch",
      "getMetricData"
    );
    let modified = addOnOutputKeys.map(({ name, value }) => {
      let fieldName = utils_1.getPrettyName("getMetricData");
      return {
        name: `${fieldName}.${name}`,
        value: `addOns.${fieldName}.data..${value}`
      };
    });
    outputKeys = outputKeys.concat(modified);
    if (
      !params.resource ||
      !params.resource.context ||
      !params.resource.context.outputPath
    )
      return outputKeys;
    return this.getKeysForPath(params.resource.context.outputPath, outputKeys);
  }
  validate() {
    return new MonitoringNodeValidation_1.MonitoringNodeValidation().validate(
      this
    );
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
  getCloudProvider() {
    return cloudProvider_1.default.AWS;
  }
}
exports.MonitoringNode = MonitoringNode;
//# sourceMappingURL=MonitoringNode.js.map
